module.exports = __webpack_public_path__ + "img/success.079ec2d1.svg";